import firebase from "firebase/compat/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

// Initialize Firebase
const config = {
  apiKey: 'AIzaSyDvnK0UPqhQpIY8o-hTkYP5tmhoN4hwiMU',
  authDomain: 'messaging-b4b84.firebaseapp.com',
  databaseURL: 'https://messaging-b4b84.firebaseio.com',
  projectId: 'messaging-b4b84',
  storageBucket: '',
  messagingSenderId: '882959685209',
  appId: '1:882959685209:web:12a1cf06e686fc77284348'
};

const initializedFirebaseApp = firebase.initializeApp(config);
// const initializedFirebaseApp = firebase.initializeApp({
// 	// Project Settings => Add Firebase to your web app
//   messagingSenderId: "882959685209"
// });
const auth = null;  //firebase.auth(); 

const googleAuthProvider = (firebase && firebase.auth) ? new firebase.auth.GoogleAuthProvider() : null;
const facebookAuthProvider = (firebase && firebase.auth) ? new firebase.auth.FacebookAuthProvider() : null;
const githubAuthProvider = (firebase && firebase.auth) ? new firebase.auth.GithubAuthProvider() : null;
const twitterAuthProvider = (firebase && firebase.auth) ? new firebase.auth.TwitterAuthProvider() : null;


console.log("initializedFirebaseApp:", initializedFirebaseApp);


console.log("firebase:", firebase);
console.log("firebase.messaging:", firebase.messaging);
var messaging = getMessaging(initializedFirebaseApp);// firebase && firebase.messaging && firebase.messaging.isSupported() ? firebase.messaging() : null;
console.log("messaging:", messaging);



//var messaging = null;
if (firebase && firebase.messaging && firebase.messaging.isSupported()) {
  console.log("firebase messaging isSupported");
  messaging = initializedFirebaseApp.messaging();
  messaging.usePublicVapidKey(
    // Project Settings => Cloud Messaging => Web Push certificates
    "BBBro9B71qtbdaDoGtZrNf9NyOWswhtXq-FCEK8KfkEwARyQMrJCHDtMYxMVAm7VNDUb1nDCDWL1P6tSHB5PRnU"
  );
  
  console.log("messaging:", messaging);
}else {
  console.log("not firebase messaging isSupported");
}
const requestForToken = () => {
  return getToken(messaging, { vapidKey: 'BBBro9B71qtbdaDoGtZrNf9NyOWswhtXq-FCEK8KfkEwARyQMrJCHDtMYxMVAm7VNDUb1nDCDWL1P6tSHB5PRnU' })
    .then((currentToken) => {
      if (currentToken) {
        console.log('current token for client: ', currentToken);
        // Perform any other neccessary action with the token
        return currentToken;
      } else {
        // Show permission request UI
        console.log('No registration token available. Request permission to generate one.');
      }
    })
    .catch((err) => {
      console.log('An error occurred while retrieving token. ', err);
    });
};

const database = null; //firebase.database();

export {
  auth,
  googleAuthProvider,
  githubAuthProvider,
  facebookAuthProvider,
  twitterAuthProvider,
  messaging,
  database,
  requestForToken
};
